import * as t from "io-ts";

// Enum for CustomFieldType
export const CustomFieldTypeIO = t.union([
    t.literal("TEXT"),
    t.literal("NUMBER"),
    t.literal("BOOL"),
    t.literal("DATE"),
    t.literal("TIME"),
    t.literal("MULTILINE"),
    t.literal("EMAIL"),
    t.literal("PHONE"),
    t.literal("URL"),
]);

// CustomFieldOptionValue: { value: string; limit: number | null }
export const CustomFieldOptionValueIO = t.type({
    value: t.string,
    limit: t.union([t.number, t.null]),
});

// CustomFieldOptions: { values: CustomFieldOptionValue[]; globalLimit: number | null }
export const CustomFieldOptionsIO = t.type({
    values: t.array(CustomFieldOptionValueIO),
    globalLimit: t.union([t.number, t.null]),
});

// Main CustomFieldDefinition schema
export const CustomFieldDefinitionIO = t.type({
    id: t.string,
    name: t.string,
    sortIndex: t.number,
    type: CustomFieldTypeIO,
    groupName: t.union([t.string, t.null, t.undefined]),
    options: t.union([CustomFieldOptionsIO, t.null, t.undefined]),
    allowMultiple: t.union([t.boolean, t.undefined]),
});

export const EventIO = t.type({
    id: t.string,
    name: t.string,
    startDate: t.string, // ISO 8601 Instant
    endDate: t.string, // ISO 8601 Instant
    zoneId: t.string,
    customFieldDefinitions: t.array(CustomFieldDefinitionIO),

    // Additional fields from Java class
    state: t.union([t.literal("DRAFT"), t.literal("ACTIVE"), t.literal("ARCHIVED")]),
    attendanceMode: t.union([t.literal("OFFLINE"), t.literal("ONLINE"), t.literal("MIXED"), t.null]),
    visibilityGroupIds: t.array(t.string),
});

export const EventListIO = t.array(EventIO);

export const JsonPrimitiveIO = t.union([t.string, t.number, t.boolean, t.null]);

export const JsonableIO: t.RecursiveType<t.Type<any>> = t.recursion("Jsonable", () =>
    t.union([JsonPrimitiveIO, t.array(JsonableIO), t.record(t.string, JsonableIO)]),
);

export const JsonValueTypeIO = t.union([t.string, t.number, t.boolean, t.null]);

// Codec for the liquidVariables object: key-value mapping
export const LiquidVariablesIO = t.record(t.string, JsonValueTypeIO);

// Codec for event statistics
export const EventStatisticIO = t.type({
    id: t.string,
    guestCount: t.number,
    acceptedCount: t.number,
    declinedCount: t.number,
    noReplyCount: t.number,
    checkinCount: t.number,
});

// Combined codec for EventInfo
export const EventInfoIO = t.type({
    liquidVariables: LiquidVariablesIO,
    eventStatistic: t.union([EventStatisticIO, t.undefined]),
});

// Codec for guest statistics data
export const GuestStatisticIO = t.type({
    count: t.number,
    filledFields: t.record(t.string, t.number),
});

// Codec for calculated guest statistics
export const EventGuestStatisticIO = t.type({
    all: GuestStatisticIO,
    accepted: GuestStatisticIO,
    attended: GuestStatisticIO,
});

export type CustomFieldDefinition = t.TypeOf<typeof CustomFieldDefinitionIO>;
export type Event = t.TypeOf<typeof EventIO>;
export type LiquidVariables = t.TypeOf<typeof LiquidVariablesIO>;
export type EventStatistic = t.TypeOf<typeof EventStatisticIO>;
export type EventInfo = t.TypeOf<typeof EventInfoIO>;
export type GuestStatistic = t.TypeOf<typeof GuestStatisticIO>;
export type EventGuestStatistic = t.TypeOf<typeof EventGuestStatisticIO>;
